export default __webpack_public_path__ + "static/titilliumweb-semibold-webfont-60190f334eaf149915f11f358d61c189.woff2";